import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import SiteSlider from 'Components/Utility/SiteSlider/SiteSlider';
import LimitedTimeDealCard from 'Components/Cards/LimitedTimeDealCard';

export default function LimitedTimeDealsCarousel({
  gameHits,
  starDeal,
  gameBundles,
  mysteryBundles,
  giveaways,
}) {
  const sliderSettings = {
    xs: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    lg: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    xxl: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
  };

  const mysteryData = mysteryBundles[0] || gameHits[1];
  const starDealData = starDeal || gameHits[0];
  const giveawayData = giveaways[0] || gameBundles[0];

  return (
    <section className="ProductCarouselSection container">
      <div className="section-heading-container">
        <h2 className="section-title">
          <FormattedMessage
            id="limitedtimedeal.title"
            defaultMessage="Limited Time Deals"
          />
        </h2>
      </div>
      <SiteSlider sliderClass="ProductCardCarousel" sliderSettings={sliderSettings}>
        {mysteryData ? (
          <LimitedTimeDealCard hit={mysteryData} />
        ) : (
          <SkeletonLimitedTimeDealCard />
        )}
        {starDealData ? (
          <LimitedTimeDealCard hit={starDealData} />
        ) : (
          <SkeletonLimitedTimeDealCard />
        )}
        {giveawayData ? (
          <LimitedTimeDealCard hit={giveawayData} />
        ) : (
          <SkeletonLimitedTimeDealCard />
        )}
      </SiteSlider>
    </section>
  );
}

const SkeletonLimitedTimeDealCard = () => (
  <div className="FakeHitCard">
    <div className="responsive-image responsive-image--16by9" />
    <div className="FakeHitCard__strip" style={{ height: '222px' }}>
      <div className="card-icons-price-container" />
    </div>
  </div>
);

LimitedTimeDealsCarousel.propTypes = {
  gameHits: PropTypes.arrayOf(PropTypes.object),
  starDeal: PropTypes.object,
  gameBundles: PropTypes.arrayOf(PropTypes.object),
  mysteryBundles: PropTypes.arrayOf(PropTypes.object),
  giveaways: PropTypes.arrayOf(PropTypes.object),
};

LimitedTimeDealsCarousel.defaultProps = {
  gameHits: [],
  starDeal: null,
  gameBundles: [],
  mysteryBundles: [],
  giveaways: [],
};
